import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class SplitTextAnime {
    constructor() {
        this.instances = [];
        this.init();
    }

    // .js-splittext を全部拾ってtimeline作成 再生はScrollFunc側のトリガーに任せる
    init() {
        const targets = document.querySelectorAll(".js-splittext");

        targets.forEach((target) => {
            const split = new SplitText(target, {
                type: "lines,words,chars",
                linesClass: "split-line",
                charsClass: "split-char",
            });

            gsap.set(target, { perspective: 0 });

            const tl = gsap.timeline({ paused: true });
            tl.fromTo(split.chars, { yPercent: 110 }, { yPercent: 0, duration: 0.6, delay: 1, stagger: 0.05, ease: "power2.out" }, 0);
            this.instances.push({ target, split, tl });
        });
    }

    // 外から呼んで再生
    play(target) {
        const inst = this.instances.find((i) => i.target === target);
        inst?.tl.play();
    }

    revert() {
        this.instances.forEach((i) => i.split.revert());
        this.instances = [];
    }
}
